// extracted by mini-css-extract-plugin
export default {"root":"SummerSaleSidebarinfo__root--2jRd7","text":"SummerSaleSidebarinfo__text--3XqLV","image":"SummerSaleSidebarinfo__image--3EXEe"};